module.exports = __webpack_public_path__ + "static/img/COC2023-31.9ac528b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-31.png
// module id = 6Ch/
// module chunks = 0